import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";

const TicketComments = ({ ticketId, getAuthHeader }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);

  const loadComments = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/tickets/${ticketId}/comments`,
      { headers: getAuthHeader() }
    );
    setComments(res.data || []);
  };

  const submitComment = async () => {
    if (!newComment.trim()) return;
    try {
      setLoading(true);
      await axios.post(
        `${API_BASE_URL}/tickets/${ticketId}/comments`,
        { comment: newComment },
        { headers: getAuthHeader() }
      );
      setNewComment("");
      loadComments();
       toast.success("Comment added Successfully");
    } catch (err) {
      console.error(err);
      alert("Failed to add comment");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadComments();
  }, [ticketId]);

  return (
    <div>

       <ToastContainer position="bottom-right" />
      {/* ADD COMMENT */}
     <div className="card p-3 mb-3">
  <h5 className="mb-3">Comment</h5>

  <textarea
    rows={3}
    className="form-control mb-3"
    value={newComment}
    onChange={(e) => setNewComment(e.target.value)}
    placeholder="Write your comment..."
  />

  <div className="text-end">
    <button
      className="btn btn-sm btn-warning text-white px-3"
      onClick={submitComment}
  
    >
      {loading ? "Saving..." : "Save"}
    </button>
  </div>
</div>


      {/* TABLE STYLE LIST */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          Show{" "}
          <select className="form-select d-inline-block" style={{ width: 70 }}>
            <option>10</option>
            <option>25</option>
            <option>50</option>
          </select>{" "}
          entries
        </div>
        <div>
          Search:{" "}
          <input
            className="form-control d-inline-block"
            style={{ width: 200 }}
            disabled
          />
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped">
          <tbody>
            {comments.length === 0 && (
              <tr>
                <td>No comments found</td>
              </tr>
            )}

            {comments.map((c) => (
              <tr key={c.id}>
                <td>
                  <div className="d-flex align-items-start">
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                      alt="user"
                      width="40"
                      height="40"
                      className="rounded-circle me-3"
                    />
                    <div>
                      <b>{c.user_name}</b>{" "}
                      <small className="text-muted">({c.user_id})</small>
                      <br />
                      <span>{c.comment}</span>
                      <br />
                      <small className="text-muted">{c.created_at}</small>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <div>Showing {comments.length} of {comments.length} entries</div>
        <div>
          <button className="btn btn-light btn-sm me-2">Previous</button>
          <button className="btn btn-warning btn-sm text-white">1</button>
          <button className="btn btn-light btn-sm ms-2">Next</button>
        </div>
      </div>
    </div>
  );
};

export default TicketComments;
